// U-04 fase a2 · lo que la captura rápida calcula sin pintar nada.
//
// Aparte de la pantalla por la regla de la casa (un .jsx exporta solo
// componentes) y para que el texto de cada regla —el motivo del botón
// apagado, la banda sin red— exista UNA vez.

/** «3,5» → «3.5»; sin espacios. */
export function normalizarCantidad(texto) {
  return String(texto ?? '').trim().replace(/\s+/g, '').replace(',', '.');
}

const FORMA_CANTIDAD = /^\d{1,11}(\.\d{1,3})?$/;

/** Una cantidad que el servidor acepta: mayor que cero, hasta 3 decimales. */
export function cantidadValida(texto) {
  const c = normalizarCantidad(texto);
  return FORMA_CANTIDAD.test(c) && Number(c) > 0;
}

/**
 * Por qué «Guardar y siguiente» no se puede pulsar, o ''. El orden es el
 * del formulario: primero el producto, después cuántas hay.
 */
export function motivoCaptura({ codigo = '', producto = { estado: 'esperando' }, nombre = '', cantidad = '' }) {
  const e = producto?.estado;
  if (e === 'esperando') {
    return codigo ? 'Pulsa «Buscar» para comprobar el código.'
      : 'Escanea o escribe el código, o pulsa «No tiene código».';
  }
  if (e === 'buscando') return 'Comprobando el código…';
  if (e === 'pieza') {
    return `El código ${codigo} es de una pieza con número de serie, y aquí se cargan cantidades. `
      + 'Da de alta cada pieza con su serie en Recepción.';
  }
  if (e === 'otro') return `El código ${codigo} no es de un producto. Escanea el código del producto.`;
  if ((e === 'nuevo' || e === 'sin_codigo') && !String(nombre).trim()) return 'Escribe cómo se llama el producto.';
  const c = normalizarCantidad(cantidad);
  if (!c || !(Number(c) > 0)) return 'La cantidad tiene que ser mayor que cero.';
  if (!FORMA_CANTIDAD.test(c)) return 'Escribe la cantidad con números, hasta 3 decimales (por ejemplo 2.5).';
  return '';
}

/** La banda sin red, con el número concordado. */
export function textoPendientes(n) {
  if (!n) return 'Sin conexión. Lo que captures se guarda en este teléfono y se envía solo al volver la señal.';
  return Number(n) === 1
    ? 'Sin conexión. 1 captura guardada en este teléfono; se envía sola al volver la señal.'
    : `Sin conexión. ${n} capturas guardadas en este teléfono; se envían solas al volver la señal.`;
}

/** «1 capturado en esta serie», «12 capturados en esta serie». */
export function textoSerie(n) {
  return Number(n) === 1 ? '1 capturado en esta serie' : `${n} capturados en esta serie`;
}

export const avisoGuardada = (cantidad, producto) => `Guardado: ${cantidad} de «${producto}». Sigue con el siguiente.`;
export const avisoCola = () => 'Guardado en este teléfono. Se envía solo al volver la señal.';
